import { Button } from "@/components/ui/button";
import { Infinity, Shield, Calendar } from "lucide-react";
import { buildGeneralWhatsAppLink } from "@/utils/whatsapp";
import { trackClickWhatsApp } from "@/utils/analytics";

export const DASHero = () => {
  const handleWhatsAppClick = () => {
    trackClickWhatsApp('hero');
    const message = "Hallo! Ich brauche einen Mietwagen in Baar. Daten: [Datum], [Tage]. Klasse: [PKW/Transporter]. KM: unbegrenzt. Bitte Verfügbarkeit & Preis bestätigen.";
    window.open(buildGeneralWhatsAppLink(message), '_blank');
  };

  const scrollToCars = () => {
    document.getElementById('cars-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-[80vh] md:min-h-[90vh] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="/hero-background.png" 
          alt=""
          className="w-full h-full object-cover"
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/50 to-black/40" />
      </div>
      
      <div className="container mx-auto px-4 py-16 md:py-20 relative z-10">
        <div className="max-w-4xl">
          {/* Hero Slogan Image */}
          <div className="mb-8">
            <img 
              src="/das-slogan-hero.jpg" 
              alt="DAS - Ihr Vertrauen ist unser Antrieb" 
              className="w-full max-w-2xl h-auto"
              fetchPriority="high"
              decoding="async"
              width="768"
              height="auto"
            />
          </div>
          
          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 mb-12">
          <Button 
            size="lg" 
            onClick={handleWhatsAppClick}
            className="bg-gold hover:bg-gold-hover active:bg-gold-hover text-white font-semibold text-lg px-8 py-6 transition-colors duration-200 touch-manipulation"
          >
            Auf WhatsApp anfragen
          </Button>
          <Button 
            size="lg" 
            variant="outline"
            onClick={scrollToCars}
            className="border-2 border-gold text-gold hover:bg-gold hover:text-white active:bg-gold active:text-white font-semibold text-lg px-8 py-6 transition-colors duration-200 touch-manipulation"
          >
            Fahrzeuge ansehen
          </Button>
          </div>
          
          {/* Trust Bar */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 max-w-3xl">
            <div className="flex items-center gap-3 bg-white p-3 md:p-4 rounded-lg shadow-card">
              <Infinity className="h-5 w-5 md:h-6 md:w-6 text-gold flex-shrink-0" />
              <span className="text-xs md:text-sm font-medium text-gray-700">Unbegrenzte KM</span>
            </div>
            <div className="flex items-center gap-3 bg-white p-3 md:p-4 rounded-lg shadow-card">
              <Shield className="h-5 w-5 md:h-6 md:w-6 text-gold flex-shrink-0" />
              <span className="text-xs md:text-sm font-medium text-gray-700">Vollkasko inkl. (SB CHF 1'000)</span>
            </div>
            <div className="flex items-center gap-3 bg-white p-3 md:p-4 rounded-lg shadow-card sm:col-span-2 md:col-span-1">
              <Calendar className="h-5 w-5 md:h-6 md:w-6 text-gold flex-shrink-0" />
              <span className="text-xs md:text-sm font-medium text-gray-700">Wochen-/Monatspreise auf Anfrage</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
